import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import { BodyParent, BodyChildren } from './animation/variants';

import Sponsors from './Sponsors';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#CDD4EC',
    width: '100%',
    color: '#FFFFFF',
  },
  black: {
    color: 'black',
  },
  bodyThree: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      padding: '30px 20px 20px 20px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '30px 0px 30px 0px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '30px 0px 50px 0px',
    },
  },
  sponsorText: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      padding: '0px 75px',
    },
  },
  sponsorDescription: {
    color: 'black',
    marginTop: '10px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
      lineHeight: '23px',
      letterSpacing: '-0.03rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 24,
      lineHeight: '31px',
      letterSpacing: '-0.04rem',
    },
  },
  sponsorButton: {
    borderRadius: '4px',
    textTransform: 'none',
  },
  pencilHolderWrapper: {
    display: 'flex',
    marginRight: 'auto',
  },
  pencilHolder: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      width: '400px',
      height: '410px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '500px',
      height: '510px',
    },
  },
  pastSponsorsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '50px',
  },
  pastSponsorTitle: {
    textAlign: 'center',
    letterSpacing: '-0.04em',
  },
  pastSponsorDescription: {
    height: '130px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '310px',
      fontSize: 18,
      lineHeight: '23px',
    },
    [theme.breakpoints.up('md')]: {
      width: '455px',
      fontSize: 24,
      lineHeight: '31px',
    },
  },
  pastSponsorsImage: {
    [theme.breakpoints.down('sm')]: {
      width: '310px',
      height: '470px',
    },
    [theme.breakpoints.up('md')]: {
      width: '750px',
      height: '1100px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '920px',
      height: '1400px',
    },
  },
  hexGroupLeftWrapper: {
    width: '10px',
    height: '10px',
    marginRight: '-1125px',
  },
  hexGroupLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      // marginTop: '150px',
      width: '340px',
      height: '380px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '440px',
      height: '480px',
      // marginTop: '200px',
    },
  },
  hexGroupRightWrapper: {
    width: '10px',
    height: '10px',
    marginLeft: '-2000px',
  },
  hexGroupRight: {
    transform: 'rotate(13.6deg)',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      width: '340px',
      height: '380px',
      marginTop: '150px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '440px',
      height: '480px',
      // marginTop: '1100px',
    },
    sponsorButtonText: {
      color: '#FFFFFF',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      textTransform: 'none',
      fontSize: '18px',
    },
  },
}));

const Wrapper = styled.div`
  display: flex;
  justify-content: space-around;
`;

const SponsorTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 700px;
  margin-left: auto;
`;

const BodyThree = () => {
  const [ref, inView] = useInView({
    rootMargin: '-100px 100px',
    triggerOnce: true,
  });

  const classes = useStyles();

  return (
    <motion.div>
      <Wrapper className={classes.root}>
        <Grid container>
          <Grid item xs={false} sm={false} md={false} lg={1} xl={1} />
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={10}
            xl={10}
            className={classes.bodyThree}>
            <motion.div
              className={classes.sponsorText}
              ref={ref}
              variants={BodyParent}
              initial="initial"
              animate={inView ? 'enter' : 'initial'}>
              <SponsorTextWrapper id="sponsors">
                <motion.div variants={BodyChildren}>
                  <Typography className={classes.black} variant="h2">
                    Interested in Becoming a Sponsor?
                  </Typography>
                </motion.div>
                <motion.p
                  className={classes.sponsorDescription}
                  variants={BodyChildren}>
                  Over the past six years, our sponsors have made it possible
                  for us to bring together students from across Canada for a
                  weekend of learning, building, and competing. Hack Western
                  would not be where it is today without the generosity of our
                  sponsors.
                  <br />
                  <br />
                  Interested in making an impact on the next generation of
                  problem-solvers? Let’s get in touch! Email us at
                  hello@hackwestern.com
                </motion.p>
                <motion.div variants={BodyChildren}>
                  <Link href="mailto:hello@hackwestern.com">
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.sponsorButton}>
                      <Typography
                        variant="h4"
                        className={classes.sponsorButtonText}>
                        Become a Sponsor
                      </Typography>
                    </Button>
                  </Link>
                </motion.div>
              </SponsorTextWrapper>
              <motion.div
                className={classes.pencilHolderWrapper}
                variants={BodyChildren}>
                <img
                  src={require('./assets/pencil-holder.png')}
                  alt="pencil-holder"
                  className={classes.pencilHolder}
                />
              </motion.div>
            </motion.div>
            <div className={classes.pastSponsorsWrapper}>
              {/* <div className={classes.hexGroupLeftWrapper}>
              <img
                src={require('./assets/hex-group.png')}
                alt="hex-group-left"
                className={classes.hexGroupLeft}
              />
            </div>
            <div className={classes.hexGroupRightWrapper}>
              <img
                src={require('./assets/hex-group.png')}
                alt="hex-group-right"
                className={classes.hexGroupRight}
              />
            </div> */}
              <Sponsors />
            </div>
          </Grid>
          <Grid item xs={false} sm={false} md={false} lg={1} xl={1} />
        </Grid>
      </Wrapper>
    </motion.div>
  );
};

export default BodyThree;
